import React from 'react';
import { observer } from 'mobx-react';

import MuiPaper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { Link } from '@this/shared/ui/navigations/link';
import type SearchTrackingLog from '@this/src/domain/search_tracking_log';
import {
  SEARCH_TRACKING_LOG_STATUS_LABELS,
  SEARCH_TRACKING_PATH_LABELS
} from '@this/src/domain/search_tracking_log';
import type { SearchType } from '@this/src/domain/search_query';
import { SEARCH_TYPE_LABELS } from '@this/src/domain/search_query';

interface Props {
  searchTrackingLog: SearchTrackingLog;
  onClick: () => void;
}

const SearchTrackingDetailLog: React.FC<Props> = observer(({ searchTrackingLog: log, onClick }) => {
  return (
    <MuiPaper style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '16px', width: '100%' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <Link onClick={onClick}>
          <Typography style={{ fontSize: '1rem', fontWeight: 'bold' }}>
            {SEARCH_TRACKING_PATH_LABELS[log.path]}({log.action})
          </Typography>
        </Link>
        <Typography style={{ fontSize: '0.8rem', color: '#7d7d7d' }}>
          {log.createdAt.format('YYYY/MM/DD HH:mm')}
        </Typography>
      </div>
      {log.repository && (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
          <div style={{ flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '100px' }}>レポジトリ</Typography>
              <Typography style={{ flex: 1 }}>{log.repository}</Typography>
            </div>
          </div>
        </div>
      )}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
        <div style={{ flex: 0.7 }}>
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Typography style={{ width: '100px' }}>ステータス</Typography>
            <Typography style={{ flex: 1 }}>{SEARCH_TRACKING_LOG_STATUS_LABELS[log.status]}</Typography>
          </div>
          {log.searchType && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '100px' }}>検索種別</Typography>
              <Typography style={{ flex: 1 }}>{SEARCH_TYPE_LABELS[log.searchType as SearchType]}</Typography>
            </div>
          )}
        </div>
        <div style={{ flex: 1 }}>
          {log.origin && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '100px' }}>出発・目的地</Typography>
              <Typography style={{ flex: 1 }}>
                {log.origin}
                {log.destination && ' → '}
                {log.destination}
              </Typography>
            </div>
          )}
          {log.originLatitude && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '100px' }}>出発地LatLng</Typography>
              <Typography style={{ flex: 1 }}>
                {log.originLatitude}
                {log.originLongitude && ', '}
                {log.originLongitude}
              </Typography>
            </div>
          )}
          {log.destinationLatitude && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '100px' }}>目的地LatLng</Typography>
              <Typography style={{ flex: 1 }}>
                {log.destinationLatitude}
                {log.destinationLongitude && ', '}
                {log.destinationLongitude}
              </Typography>
            </div>
          )}
        </div>
        <div style={{ flex: 1 }}>
          {log.tripId && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '150px' }}>Trip ID</Typography>
              <Typography style={{ flex: 1 }}>{log.tripId}</Typography>
            </div>
          )}
          {log.searchQueryId && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '150px' }}>Search Query ID</Typography>
              <Typography style={{ flex: 1 }}>{log.searchQueryId}</Typography>
            </div>
          )}
          {log.searchQueryItemId && (
            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
              <Typography style={{ width: '150px' }}>Search Query Item ID</Typography>
              <Typography style={{ flex: 1 }}>{log.searchQueryItemId}</Typography>
            </div>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            width: '100px',
            height: '100%'
          }}
        >
          <Link href={log.bugsnagLink || '#'} isExternal target="_blank">
            Bugsnag
          </Link>
        </div>
      </div>
      {log.path === 'hotels__index' && log.slideSuggestionLogs && log.slideSuggestionLogs.length > 0 && (
        <div
          style={{
            marginTop: '16px',
            padding: '12px',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px'
          }}
        >
          <Typography style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '0.9rem' }}>
            宿泊地スライド提案ログ
          </Typography>
          <ul style={{ margin: 0, paddingLeft: '20px', listStyleType: 'disc' }}>
            {log.slideSuggestionLogs.map((logMessage, index) => (
              <li key={index} style={{ fontSize: '0.85rem', marginBottom: '4px', color: '#7d7d7d' }}>
                {logMessage}
              </li>
            ))}
          </ul>
        </div>
      )}
    </MuiPaper>
  );
});

export default SearchTrackingDetailLog;
